import type { TrackingEvent } from '@marketplace-web/observability/event-tracker-data'
import { ClickableElement } from 'constants/tracking/clickable-elements'

type LandingPageEventsArgs = {
  referrer?: string
  event?: string
  target?: ClickableElement
  targetDetails?: string
  deviceId?: string
}

type LandingPageEventsExtra = {
  referrer?: string
  event?: string
  target?: ClickableElement
  target_details?: string
  device_id?: string
}

export const landingPageEvent = (args: LandingPageEventsArgs): TrackingEvent => {
  const { referrer, target, targetDetails, event: eventName, deviceId } = args

  const extra: LandingPageEventsExtra = {}

  if (targetDetails) extra.target_details = targetDetails

  if (target) extra.target = target

  if (referrer) extra.referrer = referrer

  if (deviceId) extra.device_id = deviceId

  return {
    event: eventName || 'user.view_screen',
    extra,
  }
}
